<template>
  <div class="image">
    <img :src="`${$store.state.ASSET_URL}${image}`" alt="" />
  </div>
  <div class="info">
    <h2 v-if="tall">
      <div>
        {{ title }}
        <img class="arrow" src="@/assets/icons/arrow.svg" alt="" />
      </div>
    </h2>
    <h2 v-else>
      <span>{{ leadingTitle }}</span>
      <div>
        {{ title }}
        <span
          >{{ trailingTitle
          }}<img class="arrow" src="@/assets/icons/arrow.svg" alt=""
        /></span>
      </div>
    </h2>
    <p class="cta" v-if="cta">
      <img src="@/assets/icons/sale.svg" alt="" /> {{ cta }}
    </p>
    <transition
      mode="out-in"
      @before-enter="beforeEnter"
      @enter="enter"
      @after-enter="afterEnter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <p class="description" v-show="active">{{ description }}</p>
    </transition>
  </div>
</template>

<script setup>
const props = defineProps({
  tall: Boolean,
  short: Boolean,
  active: Boolean,
  trailingTitle: String,
  leadingTitle: String,
  cta: String,
  title: String,
  description: String,
  image: String,
});
function beforeEnter(el) {
  el.style.height = 0;
}
function enter(el) {
  el.style.height = el.scrollHeight + "px";
}
function afterEnter(el) {
  //el.style.height = "auto";
}

function beforeLeave(el) {
  el.style.height = el.scrollHeight + "px";
}
function leave(el) {
  el.style.height = "0px";
}
</script>

<style lang="scss" scoped>
h2 {
  font-family: "United Sans Cd Md";
  font-weight: 500;
  span {
    font-family: "United Sans Cd Hv";
    font-weight: 900;
  }
  img {
    margin-left: 12px;
    width: 7px;
    vertical-align: middle;
  }
}
.cta {
  font-family: "United Sans Cd Bd";
  font-weight: bold;
  font-size: 1.785em;
  line-height: 1;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #54585a;
  margin-bottom: 8px;
}
.image {
    flex-grow: 1;
    overflow: hidden;
    position: relative;
    min-height: 200px;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      transition: all 0.5s;
    }
  }
  .info {
    text-align: left;
    padding: 1rem 4rem;
  }
  .description {
    font-family: "PF DinDisplay Pro";
    font-weight: 500;
    transform-origin: bottom left;
    transition: opacity 0.5s, height 0.5s;
    opacity: 0;
    transform: scale(0) translateY(50px);
    display: block !important;
    font-size: 1.5em;
    line-height: 1;
    color: #54585a;
    text-transform: none;
    height: 0;
    overflow: hidden;
    margin-top:13px;
  }
  .arrow {
    transition: all 0.5s 0.1s, height 0.5s 0s;
    display: inline-block;
  }
</style>